import React, {Component} from 'react';
import {Button, Icon, Message} from 'semantic-ui-react';
import * as XLSX from 'xlsx';
import Styles from './ProveedorImport.module.css';

const encabezadosEsperados = ['nombre', 'telefono', 'correo', 'direccion'];

const normalizarTexto = value => String(value || '')
    .trim()
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');

class ProveedorImport extends Component {
    state = {
        abierto: false,
        importando: false,
        resultado: null,
    };

    fileInput = React.createRef();

    importarArchivo = async event => {
        const input = event.target;
        const file = input.files[0];
        if(!file) return;

        this.setState({importando: true, resultado: null});
        try {
            const workbook = XLSX.read(await file.arrayBuffer(), {type: 'array'});
            const sheet = workbook.Sheets[workbook.SheetNames[0]];
            const rows = XLSX.utils.sheet_to_json(sheet, {header: 1, defval: ''});
            const headers = (rows[0] || []).slice(0, encabezadosEsperados.length).map(normalizarTexto);

            if(encabezadosEsperados.some((header, index) => headers[index] !== header)) {
                throw new Error('Los encabezados no coinciden con la plantilla de proveedores.');
            }

            const nombresExistentes = new Set(
                (this.props.proveedores || []).map(proveedor => normalizarTexto(proveedor.nombre))
            );
            const nombresDelArchivo = new Set();
            const proveedores = [];
            let duplicados = 0;

            rows.slice(1).forEach(row => {
                const nombre = String(row[0] || '').trim();
                if(!nombre || normalizarTexto(nombre).startsWith('ejemplo:')) return;

                const nombreNormalizado = normalizarTexto(nombre);
                if(nombresExistentes.has(nombreNormalizado) || nombresDelArchivo.has(nombreNormalizado)) {
                    duplicados++;
                    return;
                }

                nombresDelArchivo.add(nombreNormalizado);
                proveedores.push({
                    nombre: nombre.toUpperCase(),
                    telefono: String(row[1] || '').trim(),
                    correo: String(row[2] || '').trim(),
                    direccion: String(row[3] || '').trim(),
                });
            });

            if(!proveedores.length && !duplicados) {
                throw new Error('El archivo no contiene proveedores para importar.');
            }

            await Promise.all(proveedores.map(proveedor => this.props.addProveedor(proveedor)));
            const importados = proveedores.length;
            this.setState({
                resultado: {
                    success: true,
                    text: `${importados} ${importados === 1 ? 'proveedor importado' : 'proveedores importados'}; ${duplicados} ${duplicados === 1 ? 'duplicado ignorado' : 'duplicados ignorados'}.`,
                },
            });
        }
        catch(error) {
            this.setState({
                resultado: {success: false, text: error.message || 'No fue posible leer el archivo.'},
            });
        }
        finally {
            this.setState({importando: false});
            input.value = '';
        }
    };

    render() {
        return (
            <div className={`${Styles.container} ${this.state.abierto ? Styles.containerOpen : ''}`}>
                {!this.state.abierto ? <Button type='button' basic onClick={() => this.setState({abierto: true, resultado: null})}>
                    <Icon name='upload' />Importar
                </Button> : null}

                {this.state.abierto ?
                    <div className={Styles.panel}>
                        <div className={Styles.panelHeader}>
                            <div>
                                <strong>Importar proveedores desde Excel</strong>
                                <p>Descarga la plantilla o selecciona un archivo ya preparado.</p>
                            </div>
                            <Button type='button' basic onClick={() => this.setState({abierto: false, resultado: null})}>
                                <Icon name='arrow left' />Volver al formulario
                            </Button>
                        </div>
                        <div className={Styles.options}>
                            <Button as='a' basic href='/templates/plantilla-proveedores.xlsx' download='plantilla-proveedores.xlsx'>
                                <Icon name='download' />Descargar plantilla
                            </Button>
                            <Button type='button' basic loading={this.state.importando} onClick={() => this.fileInput.current.click()}>
                                <Icon name='file excel outline' />Seleccionar archivo
                            </Button>
                            <input ref={this.fileInput} className={Styles.fileInput} type='file' accept='.xls,.xlsx' onChange={this.importarArchivo} />
                        </div>
                        {this.state.resultado ?
                            <Message positive={this.state.resultado.success} negative={!this.state.resultado.success} size='small'>
                                {this.state.resultado.text}
                            </Message>
                        :null}
                    </div>
                :null}
            </div>
        );
    }
}

export default ProveedorImport;
